export const PLATFORM_NAME = 'ReLIGA';

export const PLATFORM_SHORT_NAME = 'ReLIGA';

export const PLATFORM_DESCRIPTION = 'Vitrine de doações da comunidade Facens — compartilhe, encontre e doe itens com quem precisa.';

export const PLATFORM_THEME_COLOR = '#0B2540';

export const PLATFORM_OG_IMAGE = 'assets/images/logo-religa.png';

export const PLATFORM_LOGO = 'assets/images/logo-religa.png';

export const PLATFORM_LOGO_ICON = 'assets/images/logo-religa-icon.png';
